'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.core.search.cb-search-form', []);

_module.directive('cbSearchForm', cbSearchFormDirective);

exports.default = _module;


function cbSearchFormDirective() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'searchForm',
        controller: 'cbSearchFormController',
        template: "<gcse:searchbox-only ng-if=\"!searchForm.onResultsPage && !searchForm.hideGoogleSearch\"\r\n                     resultsUrl=\"{{searchForm.resultsUrl}}\"\r\n                     refinementStyle=\"{{searchForm.refinementStyle}}\"></gcse:searchbox-only>\r\n\r\n<span ng-if=\"searchForm.onResultsPage && !searchForm.hideGoogleSearch\">\r\n    U bent op de zoekpagina\r\n</span>\r\n\r\n<div ng-if=\"searchForm.hideGoogleSearch\">\r\n    <input class=\"no-cookie-search-input col-sm-8 col-xs-12\" placeholder=\"Voer een trefwoord in\" type=\"text\" ng-model=\"cbSearchbox.noCookieSearchInput\" ng-focus=\"cbSearchbox.setSearch()\"/>\r\n    <a class=\"btn btn-xs search\" target=\"_blank\" rel=\"noopener\" id=\"submitSearch\" title=\"Google Zoek\" ng-href=\"https://www.google.nl/search?q=site:www.centraalbeheer.nl+{{cbSearchbox.noCookieSearchInput || ''}}\">Zoek met Google</a>\r\n</div>\r\n"
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search/cb-search-form.directive.js
// module id = 819
// module chunks = 0